import Vue from 'vue'
import Router from 'vue-router'
import routerModules from './router-modules'
import LayoutIndex from '../layouts/index.vue'
import NewLayoutIndex from "@/layouts/NewIndex.vue";

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/client2',
  },
  // {
  //   path: '/index',
  //   name: 'index',
  //   component: () => import('@/views/Index'),
  //   hidden: true,
  // },
  {
    path: '/index2',
    redirect: '/client2',
  },
  {
    path: '/client',
    name: 'client',
    component: LayoutIndex,
    children:[
      {
        path: '',
        redirect: 'newIndex'
      },
      {
        path: 'newIndex',
        name: 'new-index',
        component: () => import('@/views/new/index.vue')
      },
      {
        path: 'order',
        name: 'client-order',
        component: () => import('@/views/new/order/order.vue'),
        hidden: true,
      },
    ]
  },
  {
    path: '/transitionOptions',
    name: 'transitionOptions',
    component: () => import('@/views/new/transitionOptions/transitionOptions.vue'),
  },
  {
    path: '/newIndex',
    name: 'new-index',
    component: () => import('@/views/new/index.vue')
  },
  {
    path: '/order',
    name: 'client-order',
    component: () => import('@/views/new/order/order.vue'),
    hidden: true,
  },
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('@/views/login/newWXLogin.vue'),
    hidden: true,
  },
  {
    path: '/newWXLogin',
    name: 'newWXLogin',
    component: () => import('@/views/login/newWXLogin.vue'),
    hidden: true,
  },
  {
    path: '/binding',
    component: () => import('@/views/login/binding'),
    hidden: true,
  },
  {
    path: '/OrderEvaluation',
    component: () => import('@/views/OrderEvaluation'),
    hidden: true,
  },
  {
    path: '/OrderCheck',
    component: () => import('@/views/OrderCheck'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },
  {
    path: '/appDiscountCoupon',
    component: () => import('@/views/app/appDiscountCoupon'),
    hidden: true,
  },
  {
    path: '/appAppraise',
    component: () => import('@/views/app/appraise/RatingPage.vue'),
    hidden: true,
  },
  {
    path: '/sampleImage',
    component: () => import('@/views/sampleImage/sampleImage.vue'),
    hidden: true,
  },
  {
    path: '/si/:id',
    component: () => import('@/views/sampleImage/sampleImages.vue'),
    hidden: true,
  },
  {
    path: '/Zip/:id',
    component: () => import('@/views/downLoadZip/downLoadZip.vue'),
    hidden: true,
  },
  {
    path: '/zip/:id',
    component: () => import('@/views/downLoadZip/downLoadZip.vue'),
    hidden: true,
  },
  {
    path: '/sampleImages/:id',
    component: () => import('@/views/sampleImage/sampleImages.vue'),
    hidden: true,
  },
  {
    path: '/progressManagement',
    component: () => import('@/views/app/progressManagement/progressManagement.vue'),
    hidden: true,
  },
  {
    path: '/videoViewing',
    component: () => import('@/views/video/videoViewing.vue'),
    hidden: true,
  },
  {
    path: '/client2',
    name: 'client2',
    component: NewLayoutIndex,
    children:[
      {
        path: '',
        redirect: 'newIndex2'
      },
      {
        path: 'newIndex2',
        name: 'new-index2',
        component: () => import('@/views/new/index2.vue'),
        hidden: true,
      },
      {
        path: 'newOrder2',
        name: 'new-order2',
        component: () => import('@/views/new/order2/order2.vue'),
        hidden: true,
      },
      {
        path: 'selectPage',
        name: 'select-page',
        component: () => import('@/views/new/selectPage/selectPage.vue'),
        hidden: true,
      },
    ]
  },
  // {
  ...routerModules
]

export const asyncRoutes = [
  // ...routerModules,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    base: '/2c/',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js